/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.FAQ";
        const DEFAULT_ICON_COLLAPSED = "wpt-font wpt-font-icon_Right";
        const DEFAULT_ICON_EXPANDED = "wpt-font wpt-font-icon_Down";
        class FAQWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("FAQWidgetTypeClass.createInstance()");
                    return new FAQInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("FAQWidgetTypeClass._storeHtml()");
                    FAQInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("FAQWidgetTypeClass::constructor");
                this._allowedOnLogon = true;
                if (FAQInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/FAQ/faq.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.FAQWidgetTypeClass = FAQWidgetTypeClass;
        class FAQInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._holder = null;
                this._iconCollapsed = null;
                this._iconExpanded = null;
                this._tempDOM = null;
                this._loader = null;
                this._usageAllowed = true;
                this.presentInstance = () => {
                    this._log.info("FAQInstanceClass.presentInstance()");
                    this._container.innerHTML = FAQInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._holder = this._container.querySelector('#faqContent');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#faqWidgetTitle'), 'STR_WPT_FAQ');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#faqLoading'), 'STR_WPT_LOADING');
                    let conf = this._config;
                    if (conf.hasOwnProperty('IconCollapsed') && conf.IconCollapsed.length > 0) {
                        this._iconCollapsed = conf.IconCollapsed.split(" ");
                    }
                    else {
                        this._iconCollapsed = DEFAULT_ICON_COLLAPSED.split(" ");
                    }
                    if (conf.hasOwnProperty('IconExpanded') && conf.IconExpanded.length > 0) {
                        this._iconExpanded = conf.IconExpanded.split(" ");
                    }
                    else {
                        this._iconExpanded = DEFAULT_ICON_EXPANDED.split(" ");
                    }
                    this._holder.innerHTML = "";
                    if (this._usageAllowed) {
                        this._core.Functions.showElement(this._loader);
                        if (conf.hasOwnProperty('Path')) {
                            this._core.Loader.getUnversionedJSON(conf.Path, this._fillFAQ, this._callErrorHandler);
                        }
                        else if (conf.hasOwnProperty('Query')) {
                            let requestSearch = this._core.OBHelper.compileFlexSearchFromQueryDef(conf.Query);
                            requestSearch.MaxHits = 1;
                            this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._getFaqJson, {}, this._callErrorHandler, this._callFailedHandler);
                        }
                        else if (conf.hasOwnProperty('FlexQuery')) {
                            let requestSearch = this._core.OBHelper.flexDefinitionToRequest(conf.FlexQuery);
                            requestSearch.MaxHits = 1;
                            this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._getFaqJson, {}, this._callErrorHandler, this._callFailedHandler);
                        }
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("FAQInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("FAQInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._getFaqJson = (response) => {
                    this._log.info("FAQInstanceClass._getFaqJson()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        let doc = response.Documents[0];
                        let url = '/OnBaseDocumentDownload.ashx?wmode=transparent&id=' + doc.ItemNum;
                        this._core.Loader.genericServiceCallTextData(url, this._receiveFaqJson, this._callErrorHandler);
                    }
                    else {
                        console.warn("no documents received");
                        this._core.Functions.hideElement(this._loader);
                    }
                };
                this._receiveFaqJson = (textData) => {
                    this._log.info("FAQInstanceClass._receiveFaqJson()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    try {
                        let faqData = JSON.parse(textData.ContentText);
                        this._fillFAQ(faqData);
                    }
                    catch (ex) {
                        console.warn("failed to get FAQ JSON: " + ex.message);
                        let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FAQ_ERROR_MSG');
                        let errorMsg = msgPrefix + ": " + ex.message;
                        this.addError(errorMsg);
                        this._core.Functions.hideElement(this._loader);
                    }
                };
                this._fillFAQ = (faqData) => {
                    this._log.info("FAQInstanceClass._fillFAQ()");
                    this._holder.innerHTML = "";
                    this._core.Functions.hideElement(this._loader);
                    if (faqData.hasOwnProperty('FAQs')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("found FAQs");
                        }
                        let faqSets = faqData.FAQs;
                        let faqSetsLength = faqSets.length;
                        let questions = null;
                        let selectedLang = this._core.Locale.getSelectedLocale().LangFileCode;
                        for (let i = 0; i < faqSetsLength; i++) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at FAQ set: " + (i + 1));
                            }
                            let faqSet = faqSets[i];
                            if (faqSet.hasOwnProperty('Lang')) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("looking at FAQ set for language: " + faqSet.Lang);
                                }
                                if (faqSet.Lang === selectedLang) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("is selected language");
                                    }
                                    if (faqSet.hasOwnProperty('Questions')) {
                                        if (this._log.isTraceEnabled()) {
                                            this._log.trace("questions set");
                                        }
                                        questions = faqSet.Questions;
                                    }
                                    break;
                                }
                            }
                        }
                        if (questions == null) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("questions not set yet, using first FAQ set");
                            }
                            let faqSet = faqSets[0];
                            if (faqSet != null && faqSet != undefined) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("using first FAQ set");
                                }
                                if (faqSet.hasOwnProperty('Questions')) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("questions set");
                                    }
                                    questions = faqSet.Questions;
                                }
                            }
                            else {
                                console.warn("no FAQ set found");
                            }
                        }
                        if (questions != null) {
                            this._tempDOM = document.createDocumentFragment();
                            questions.forEach(this._appendQuestion);
                            this._holder.appendChild(this._tempDOM);
                            this._tempDOM = null;
                        }
                    }
                };
                this._appendQuestion = (faq, index) => {
                    this._log.info("FAQInstanceClass._appendQuestion()");
                    let faqDiv = document.createElement('div');
                    this._tempDOM.appendChild(faqDiv);
                    faqDiv.classList.add('faq-item');
                    let faqHeading = document.createElement('div');
                    faqDiv.appendChild(faqHeading);
                    faqHeading.classList.add('faq-heading');
                    let iconSspan = document.createElement('span');
                    faqHeading.appendChild(iconSspan);
                    iconSspan.classList.add('faq-heading__icon', ...this._iconCollapsed);
                    faqHeading.appendChild(document.createTextNode(faq.Question));
                    let answerDiv = document.createElement('div');
                    faqDiv.appendChild(answerDiv);
                    answerDiv.id = "faqContent-" + index;
                    answerDiv.classList.add('faq-answer', WPTNamespace.HIDDEN_CLASS);
                    if (typeof faq.Answer === 'string') {
                        answerDiv.appendChild(document.createTextNode(faq.Answer));
                    }
                    else {
                        faq.Answer.forEach(p => {
                            let paragraph = document.createElement('p');
                            answerDiv.appendChild(paragraph);
                            paragraph.appendChild(document.createTextNode(p));
                        }, this);
                    }
                    faqHeading.addEventListener('click', this._toggleQuestion.bind(this, iconSspan, answerDiv));
                };
                this._toggleQuestion = (iconElement, answerElement) => {
                    this._log.info("FAQInstanceClass._toggleQuestion()");
                    if (answerElement.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                        answerElement.classList.remove(WPTNamespace.HIDDEN_CLASS);
                        iconElement.classList.remove(...this._iconCollapsed);
                        iconElement.classList.add(...this._iconExpanded);
                    }
                    else {
                        answerElement.classList.add(WPTNamespace.HIDDEN_CLASS);
                        iconElement.classList.remove(...this._iconExpanded);
                        iconElement.classList.add(...this._iconCollapsed);
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("FAQInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                if (!core.isUserLoggedIn() && !config.hasOwnProperty('Path') && config.hasOwnProperty('Query')) {
                    let msg = core.Locale.getTranslation('STR_WPT_LOGON_NOT_ALLOWED_SETTING') + ": Query";
                    this.addError(msg);
                    this._usageAllowed = false;
                }
            }
        }
        FAQInstanceClass.HtmlData = null;
        Widgets.FAQInstanceClass = FAQInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
